import React from 'react';
import { Header } from '../../layout';
import Sidebar from '../../layout/sidebar';

export default function HomePage () {
    return (
        <div className='home'>
            <Header/>
            <Sidebar />
        </div>
    );
}
